import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Loading } from "@/components/site/ui";
import { Panel, AdminHeading, Th, Td } from "@/components/admin/ui";

export default function AdminMemberships() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/membership-levels").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const save = async (l, field, value) => { try { await api.put(`/admin/membership-levels/${l.id}`, { [field]: value }); toast.success("Saved."); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div>
      <AdminHeading title="Membership Levels" subtitle="Configure discounts, booking windows, and access." />
      <Panel>
        {items === null ? <Loading /> : (
          <div className="overflow-x-auto"><table className="w-full min-w-[640px]">
            <thead><tr><Th>Level</Th><Th>Discount %</Th><Th>Booking Window (days)</Th><Th>Requires Approval</Th><Th>Restricted</Th></tr></thead>
            <tbody>{items.map((l) => (
              <tr key={l.id}>
                <Td><span style={{ color: l.color }}>{l.name}</span></Td>
                <Td><input type="number" defaultValue={l.discount_percent} onBlur={(e) => save(l, "discount_percent", +e.target.value)} className="bg-black/30 border border-white/10 rounded px-2 py-1 w-20 text-sm" /></Td>
                <Td><input type="number" defaultValue={l.booking_window_days} onBlur={(e) => save(l, "booking_window_days", +e.target.value)} className="bg-black/30 border border-white/10 rounded px-2 py-1 w-20 text-sm" /></Td>
                <Td><input type="checkbox" defaultChecked={l.requires_approval} onChange={(e) => save(l, "requires_approval", e.target.checked)} className="accent-gold" /></Td>
                <Td>{l.restricted ? <span className="text-red-300 text-xs">Restricted</span> : "—"}</Td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </Panel>
    </div>
  );
}
